import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';
import useAttribute from "./useAttribute";

export default function () {
  const { attributeFields, handleSubmit, setErrors } = useAttribute();
  const navigate = useNavigate();
  const { id } = useParams();

  const addCategoryAttribute = data => {
    axios.post('attributes/storeByCategory/' + id, data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Category attribute has been created successfully!', {
            icon: "success",
          });
          navigate(-1);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Add Category Attribute">
      <form className="form w-100 row" onSubmit={handleSubmit(addCategoryAttribute)}>
        {attributeFields}

        <div className="col-12 text-left">
          <SubmitButton
            title="Add"
            classes="w-auto d-inline-block"
          />
        </div>
      </form>
    </Card>
  );
}